import { useToken } from '@ori/auth';
import { useServiceUrls } from '@ori/configuration-manager';
import { useEnvironment } from '@ori/environment';
import { SWRConfig, type SWRConfiguration } from '@ori/fetching';
import { ApiClientProvider as GlobalApiClientProvider } from '@ori/global-api-client-react';
import { useLanguage } from '@ori/i18n';
import { ApiClientProvider as MobileOfficeApiClientProvider } from '@ori/mobile-office-api-client-react';
import type { FC, PropsWithChildren } from 'react';

const TIMEOUT_IN_MS = 10_000;

const swrConfig: SWRConfiguration = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: true,
};

export const ApiProvider: FC<PropsWithChildren> = ({ children }) => {
  const { formattedToken } = useToken();
  const { language } = useLanguage();
  const { tenant } = useEnvironment();
  const { mobileOfficeApiUrl, globalApiUrl } = useServiceUrls(['mobileOfficeApi', 'globalApi']);

  return (
    <SWRConfig value={swrConfig}>
      <MobileOfficeApiClientProvider
        baseUrl={mobileOfficeApiUrl}
        language={language}
        tenant={tenant}
        token={formattedToken}
        timeout={TIMEOUT_IN_MS}
      >
        <GlobalApiClientProvider
          baseUrl={globalApiUrl}
          language={language}
          tenant={tenant}
          token={formattedToken}
          timeout={TIMEOUT_IN_MS}
        >
          {children}
        </GlobalApiClientProvider>
      </MobileOfficeApiClientProvider>
    </SWRConfig>
  );
};
